import { render } from "./PaidLeavePage.vue?vue&type=template&id=2a0e600e&scoped=true"
import script from "./PaidLeavePage.vue?vue&type=script&lang=js"
export * from "./PaidLeavePage.vue?vue&type=script&lang=js"

import "./PaidLeavePage.vue?vue&type=style&index=0&id=2a0e600e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0e600e"]])

export default __exports__